module.exports = __webpack_public_path__ + "img/ill_badge_claim_confirmation.baf7e5c9.svg";